import { createContext } from "react";

// Protocol Link Context - provides protocol list for cross-protocol linking
export const ProtocolLinkContext = createContext({ protocols: [], currentProtocol: null });
